<template lang="pug" id="url_message">
  .message-wrapper(:class="{'message-webchat': inWebchat, \
                            'message-customer': message.sender_type === 'customers', \
                            'message-agent': message.sender_type === 'agents' }"
                   :style="{textAlign: textAlign}")
    template(v-if="inWebchat")
      avatar( :inWebchat="inWebchat",
              :senderType="senderType",
              :avatarPhoto="avatar",
              :senderInitials="senderInitials"
              :avatarAltText="avatarAltText")
      .agent-message-webchat-container
        .message-bubble_header
                  .message-bubble_date
                      aiq-timeago(:since="messageDate" :maxTime="maxTime")
        .message-webchat_content(
          :class="{'message-customer': senderType === 'customers',\
          'message-agent': senderType === 'agents' }")
          aiq-tooltip(:effect="'dark'",
                placement="bottom",
                :content="url",
                :open-delay="500")
            a(:href="url",
              class="link-wrapper"
              @click="onHandleClick"
              target="_blank",
              rel="noopener") Open link in a new tab
              document(:senderType="senderType", :url="url" :inWebchat="inWebchat")
          .message-webchat_content_text(v-html="content")
    .message-container(v-else
                      :class="{'message-customer': senderType === 'customers',\
                              'message-agent': senderType === 'agents' }")
      .message-item(v-if="senderType")
        avatar( :inWebchat="inWebchat",
                :senderType="senderType",
                :avatarPhoto="avatar",
                :senderInitials="senderInitials"
                :avatarAltText="avatarAltText")
        .message-bubble
          .message-bubble_header
            .message-bubble_name
              i(v-if="senderType === 'customers'",
                :title="channelInfo.title",
                :class="`aiq-ico-conversation-${channel}`")
              template(v-else)
                | {{ senderType === 'agents' ? senderName : ''}}
                .message-bubble_icon
                  i(v-if="senderType === 'customers'",
                    :title="channelInfo.title",
                    :class="`iq-ico-conversation-${channel}`")
              .message-bubble_user-name(v-if="senderType === 'customers'")
                | {{channel === "twitter" || channel === "twitter-dm" ? "@": ""}}
                | {{ message.sender.profile.preferredUsername }}
            .message-bubble_date
              aiq-timeago(:since="messageDate" :maxTime="maxTime")
          document(:senderType="senderType", :url="url" :inWebchat="inWebchat")
          .message-bubble_content(v-html="name")
      .message-system(v-else, v-html="content")

</template>
<script>
import get from 'lodash/get';
import BaseMessage from './BaseMessage/BaseMessage.vue';
import Avatar from '../../Avatar.vue';
import Document from './Document.vue';
import { handleClick } from '../MessageUtils'; // eslint-disable-line no-unused-vars

export default {
  extends: BaseMessage,
  name: 'urlMessage',
  methods: {
    // In the future, it would be nice to allow override of this.
    onHandleClick(e) {
      handleClick(window, this.url, e);
    },
  },
  components: {
    Avatar,
    Document,
  },
  props: {
    message: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    inWebchat: Boolean,
  },
  computed: {
    // For backwards compatibility, we need to support both payload.url.* and url.*
    content() {
      const content = get(
        this.message, 'payload.url.content',
        get(this.message, 'url.link.content', ''),
      );
      return this.applyFilters(content);
    },

    url() {
      let url = get(this.message, 'payload.url.link');
      if (!url) {
        url = get(this.message, 'url.link.link', '');
      }
      return url;
    },
    name() {
      let name = this.$filters.sanitize(get(this.message, 'payload.url.name'));
      if (!name) {
        name = this.$filters.sanitize(get(this.message, 'url.link.name', ''));
      }
      return name;
    },
  },
};
</script>

<style lang="scss" scoped>
.link-wrapper {
  font-size: 0px;
}
</style>
